import { type FC, useEffect } from "react";

export const keyToKeyCodeMap = {
	a: "KeyA",
	b: "KeyB",
	c: "KeyC",
	d: "KeyD",
	e: "KeyE",
	f: "KeyF",
	g: "KeyG",
	h: "KeyH",
	i: "KeyI",
	j: "KeyJ",
	k: "KeyK",
	l: "KeyL",
	m: "KeyM",
	n: "KeyN",
	o: "KeyO",
	p: "KeyP",
	q: "KeyQ",
	r: "KeyR",
	s: "KeyS",
	t: "KeyT",
	u: "KeyU",
	v: "KeyV",
	w: "KeyW",
	x: "KeyX",
	y: "KeyY",
	z: "KeyZ",
	0: "Digit0",
	1: "Digit1",
	2: "Digit2",
	3: "Digit3",
	4: "Digit4",
	5: "Digit5",
	6: "Digit6",
	7: "Digit7",
	8: "Digit8",
	9: "Digit9",
	Enter: "Enter",
	Backspace: "Backspace",
	Escape: "Escape",
	"`": "Backquote",
	"-": "Minus",
	"=": "Equal",
	"[": "BracketLeft",
	"]": "BracketRight",
	"\\": "Backslash",
	";": "Semicolon",
	"'": "Quote",
	",": "Comma",
	".": "Period",
	"/": "Slash",
	" ": "Space",
};

export type Key = keyof typeof keyToKeyCodeMap;

export type KeyboardShortcutProps = {
	shortcut: {
		key: Key;
		modifiers?: {
			ctrl?: boolean;
			alt?: boolean;
			shift?: boolean;
			meta?: boolean;
		};
	};
	onShortcutPress: () => void;
};

export const KeyboardShortcut: FC<KeyboardShortcutProps> = ({ shortcut, onShortcutPress }) => {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			const includesRequiredModifiers =
				(!shortcut.modifiers?.ctrl || e.ctrlKey) &&
				(!shortcut.modifiers?.alt || e.altKey) &&
				(!shortcut.modifiers?.shift || e.shiftKey) &&
				(!shortcut.modifiers?.meta || e.metaKey);

			// If all of the modifiers are present and the key matches, trigger the shortcut action
			if (includesRequiredModifiers && e.code === keyToKeyCodeMap[shortcut.key]) {
				e.preventDefault();
				onShortcutPress();
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [shortcut, onShortcutPress]);

	return null;
};
